import { createSlice } from '@reduxjs/toolkit';

const normalizeSocketId = (value) => {
  if (value == null || value === '') return '';
  if (typeof value === 'object' && value._id != null) return String(value._id);
  return String(value);
};

const mergeReading = (existing, reading) => ({
  ...existing,
  ...reading,
  bridgeId: normalizeSocketId(reading.bridgeId || existing?.bridgeId),
  sensorId: normalizeSocketId(reading.sensorId || existing?.sensorId),
});

const initialState = {
  latestBySensorId: {},
  socketConnected: false,
};

const sensorDataSlice = createSlice({
  name: 'sensorData',
  initialState,
  reducers: {
    setSocketConnected(state, action) {
      state.socketConnected = Boolean(action.payload);
    },
    patchLiveReading(state, action) {
      const reading = action.payload;
      if (!reading || typeof reading !== 'object') return;
      const key = normalizeSocketId(reading.sensorId || reading._id);
      if (!key) return;
      state.latestBySensorId[key] = mergeReading(state.latestBySensorId[key], reading);
    },
    setLiveReadings(state, action) {
      const readings = action.payload || [];
      const latestBySensorId = {};
      readings.forEach((reading) => {
        const key = normalizeSocketId(reading.sensorId || reading._id);
        if (key) latestBySensorId[key] = mergeReading(null, reading);
      });
      state.latestBySensorId = latestBySensorId;
    },
    clearLiveReadings(state) {
      state.latestBySensorId = {};
    },
  },
});

export const {
  setSocketConnected,
  patchLiveReading,
  setLiveReadings,
  clearLiveReadings,
} = sensorDataSlice.actions;

export const selectLatestSensorDataBySensorId = (state) => state.sensorData.latestBySensorId;
export const selectSensorSocketConnected = (state) => state.sensorData.socketConnected;

export default sensorDataSlice.reducer;
